import { create } from 'zustand';

import { useWalletStore } from './use-wallet';

export enum SocialCurrency {
    COINS = 'COINS',
    CASH = 'CASH',
}

type SocialCurrencyStore = {
    activeCurrency: SocialCurrency;
    actions: {
        setActiveCurrency: (currency: SocialCurrency) => void;
    };
};

export const useSocialCurrencyStore = create<SocialCurrencyStore>()(set => {
    return {
        activeCurrency: SocialCurrency.COINS,
        actions: {
            setActiveCurrency: (currency: SocialCurrency) => {
                set({ activeCurrency: currency });
                useWalletStore.getState().actions.loadUserWallet();
            },
        },
    };
});

export const useIsCashCurrency = () => useSocialCurrencyStore(state => state.activeCurrency === SocialCurrency.CASH);
